var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.128906,
    width: 30.6337,
    height: 28.6573,
    rx: 2.18812,
    fill: "#CD2A3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.834 4.50391V5.85126H18.1048C18.8119 5.85126 19.3821 6.42146 19.3821 7.12855V14.5551C19.8633 14.612 20.3241 14.733 20.7564 14.9108V7.43035C20.7564 5.81151 19.4542 4.50391 17.8354 4.50391H12.834ZM7.66016 9.67774V18.1445C7.66016 19.7633 8.96237 21.0655 10.5812 21.0655H13.664C13.5595 20.6522 13.5023 20.2179 13.5023 19.7721C13.5023 19.7431 13.5018 19.7148 13.5023 19.6859H10.2471C9.53999 19.6859 8.96978 19.121 8.96978 18.414V9.67774H7.66016Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6908 15.4297C16.3257 15.4297 14.4062 17.3492 14.4062 19.7143C14.4062 22.0794 16.3257 23.9935 18.6908 23.9935C21.0559 23.9935 22.9754 22.0794 22.9754 19.7143C22.9754 17.3492 21.0559 15.4297 18.6908 15.4297ZM20.561 17.8118L21.4502 18.534C18.5364 22.1575 21.4557 18.482 18.5022 22.1772L16.2494 20.0592L17.0363 19.2292L18.3836 20.4957L20.561 17.8118Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0293 8.46495L11.6232 4.87109V8.46495H8.0293Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6213 10.7188H10.4121V12.0958H11.6213V10.7188Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6213 13.5117H10.4121V14.8552H11.6213V13.5117Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6213 16.2227H10.4121V17.5997H11.6213V16.2227Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9018 11.3906H13.166V12.096H17.9018V11.3906Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4576 14.2148H13.166V14.853H16.4576V14.2148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reportsIcon.02569969ab3b4b13f98444e7c97cfe43.svg";
export { ForwardRef as ReactComponent };